import { useTranslation } from "react-i18next";
import { SEOHead } from "../components/SEOHead";
import { SiteFooter } from "../components/SiteFooter";

export default function PrivacyPage() {
  const { t } = useTranslation();
  const sections = t("privacy.sections", { returnObjects: true });

  return (
    <div className="min-h-screen bg-background" data-testid="privacy-page">
      <SEOHead title={t("privacy.title")} />
      <main className="max-w-3xl mx-auto px-4 md:px-6 py-12 md:py-20">
        <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 font-heading mb-8">{t("privacy.title")}</h1>
        <div className="prose-sm text-slate-600 space-y-6 leading-relaxed">
          <p className="text-sm text-slate-500">{t("privacy.updated")}</p>
          {Array.isArray(sections) && sections.map((s, i) => (
            <section key={i}>
              <h2 className="text-lg font-semibold text-slate-900 mb-2">{s.title}</h2>
              {s.body.split("\n\n").map((para, j) => (
                <p key={j}>{para}</p>
              ))}
            </section>
          ))}
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
